import styled from 'styled-components'

export const BlackHeading1 = styled.h1 `
color: black;
text-align: left;
text-transform: uppercase;
`
export const BlackHeading = styled.h4 `
color: black;
text-align: left;
text-transform: uppercase;
`

export const Input = styled.input `
width: 100%;
font-size: 18px;
color: black;
border: 1px solid #ddd;
cursor: text;
padding: 16px;
border-radius: 2px;
margin-bottom: 10px;
box-shadow: inset 0px 1px 8px -3px #ABABAB;
background: #fefefe;
`
export const EditorInput = styled.div `
color: black;
border: 1px solid #ddd;
cursor: text;
padding: 16px;
border-radius: 2px;
margin-bottom: 10px;
box-shadow: inset 0px 1px 8px -3px #ABABAB;
background: #fefefe;
min-height: 150px;
h2 {
  color: black;
  font-size: 1.2em;
  text-transform: uppercase;
}
`
export const BlogPostImage = styled.div `
  background: no-repeat url(${props => props.image});
  background-size:     contain;
  margin: 0 auto;
  margin-top: 10px;
  height: 50%;
  width: 100%;
`
BlogPostImage.defaultProps = {
    size: 100,
    image: "https://res.cloudinary.com/theloge/image/upload/default_profile_image.jpg"
}

export const DropzoneDiv = styled.div `
background: no-repeat url(${props => props.image});
background-size:     contain;
background-position: center center;
margin: 0 auto;
height: ${props => props.size}px;
width: auto;
max-width: 180px;
max-height: 180px;
margin-top: ${props => (180-props.size)/1.7}px
`
BlogPostImage.defaultProps = {
    size: 100,
    image: "https://res.cloudinary.com/theloge/image/upload/default_profile_image.jpg"
}



// WEBPACK FOOTER //
// /src/components/internal/BlackboardBlog/BlackboardStyle.js